export default function (Component) {
Component.options.__title = "Controlling the First Day of Week"
}